module.exports = __webpack_public_path__ + "img/logo-silent-disco.68c88909.svg";